import React, { useEffect, useState } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Divider, message } from 'antd'
import { getUser } from '../../../reducers'
import { db } from '../../../config/Fire'
import * as Constants from '../../../constants'
import FormClient from '../../containers/FormClient'
import './newClientStyles.css'

const NewClient = props => {
    const [savingClient, setSavingClient] = useState(false)

    const saveClient = client => {
        setSavingClient(true)
        try {
            const newClientKey = db.ref().child(Constants.MAIN_NODES.USERS).push().key
            client.id = newClientKey
            client.userType = Constants.USER_TYPES.CLIENT
            const date = new Date()
            const dateStr = `${date.getDate().toString().length === 1 ? '0' + date.getDate() : date.getDate()}/${(date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
            client.createDate = dateStr
            db.ref(`${Constants.MAIN_NODES.USERS}/${newClientKey}`).set(client)
            message.success('El cliente se guardo exitósamente')
            setSavingClient(false)
            props.onBack(true, client)
        } catch (err) {
            console.log(err)
            message.error('Se produjo un error al guardar el cliente. Por favor, vuelva a intentarlo')
            setSavingClient(false)
        }
    }

    return (
        <Grid className="newClientCont ">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Nuevo Cliente</h2>
                </Col>
            </Row>
            <Divider/>
            <Row center="xs">
                <Col xs={12}>
                    <FormClient clients={props.clients} onSubmitClient={saveClient}
                        isEditing={false}
                        loading={savingClient}/>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={6}>
                    <Button onClick={() => props.onBack(false)} disabled={savingClient} loading={savingClient}>
                        Salir
                    </Button>
                </Col>
            </Row>
        </Grid>
    )
}

NewClient.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(NewClient))